module.exports = __webpack_public_path__ + "static/media/vegetarian.f83e3367.png";